import { Component } from '@angular/core';
import { NavParams ,ViewController} from 'ionic-angular';
import { PageDefault } from '../PageDefault'; 

/*
  充值:deposit
*/
@Component({
  selector: 'inbox-search',
  templateUrl: 'inboxsearch.html'
})
export class InboxSearch {

    start = PageDefault.startDate();
    end = PageDefault.endDate();
    PageIndex=1;
    people:string;

    tracks = {};
    constructor(
      private viewCtrl: ViewController, 
      private navpar: NavParams) {
        this.start = navpar.data.startDate != undefined ? navpar.data.startDate : PageDefault.startDate();
        this.end = navpar.data.endDate != undefined ? navpar.data.endDate : PageDefault.endDate();
    }


    //查询条件
    applyFilters() {
        this.tracks["startDate"] = this.start;
        this.tracks["endDate"] = this.end;
        this.tracks["pageIndex"]=this.PageIndex;
        this.tracks["people"] = this.people;       
        this.dismiss(this.tracks)
    }
        
    
    //关闭
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }
}



// WEBPACK FOOTER //
// ./src/pages/inbox/inboxsearch.ts